var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "list__container" }, [
    _c("div", { staticClass: "features__wrapper" }, [
      _c(
        "div",
        {
          staticClass: "features__list",
          style: { left: _vm.sliderLeft + "px" }
        },
        _vm._l(_vm.features, function(feature, i) {
          return _c("div", { key: i, staticClass: "feature" }, [
            _c("img", { attrs: { src: feature.image, alt: "" } }),
            _vm._v(" "),
            _c("h3", [_vm._v(_vm._s(feature.title))]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(feature.content))])
          ])
        }),
        0
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "features__controllers" }, [
      _c("div", { staticClass: "img", on: { click: _vm.prevSlide } }, [
        _c("img", {
          attrs: {
            src:
              "/media/video-locator-lp-template-e/after-quiz/reviews/arrow-left.svg",
            alt: "arrow left"
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "img", on: { click: _vm.nextSlide } }, [
        _c("img", {
          attrs: {
            src:
              "/media/video-locator-lp-template-e/after-quiz/reviews/arrow-right.svg",
            alt: "arrow right"
          }
        })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }